import React, { useState, useEffect, Fragment } from 'react';
import { Breadcrumbs, H5 } from '../../../AbstractElements';
import { Card, CardBody, CardHeader, Col, Container, Row, Input, Media } from 'reactstrap';
import DataTable from 'react-data-table-component';
import { User, Edit } from 'react-feather';
import { fetchTableData } from '../../../Api/ApiMethods';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const AccidentFiles = () => {
    const [data, setData] = useState([]);
    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [search, setSearch] = useState('');
    const [totalRows, setTotalRows] = useState(0);
    const [selectedRows, setSelectedRows] = useState([]);

    const accidentFileApiUrl = process.env.REACT_APP_LACIVERT_API_ENDPOINT + '/accidentfile';
    const navigate = useNavigate();

    const handleSearch = (event) => {
        event.preventDefault();
        setSearch(event.target.value);
    };

    useEffect(() => {
        fetchTableData({
            apiEndpoint: accidentFileApiUrl,
            page,
            pageSize,
            search,
            setDataCallback: setData,
            setTotalRowsCallback: setTotalRows,
        });
    }, [page, pageSize, search]);

    const handleCustomerDetail = (customerId) => {
        navigate(`/customer/${customerId}`);
    };

    const handleCallForm = (row) => {
        const callFormId = row.callForm?.[0];
        
        if (callFormId) {
            navigate(`/callform/${callFormId}`);
        } else {
            toast.error('Bu kaza dosyası için çağrı formu bulunamadı.');
        }
    };

    const columns = [
        {
            name: 'Müşteri',
            cell: row => {
                const customerId = row.customer?.[0];
                return customerId ? (
                    <div className="btn btn-outline-primary d-flex align-items-center justify-content-center" onClick={() => handleCustomerDetail(customerId)}>
                        <User size={18}/>
                    </div>
                ) : '';
            },
            ignoreRowClick: true,
            right: true,
            button: true,
        },
        { name: 'Dosya Numarası', selector: row => row.fileNumber || '', sortable: true },
        { name: 'Dosya Durumu', selector: row => row.fileCaseStatus || '', sortable: true },
        { name: 'Plaka', selector: row => row.accident?.licensePlate?.licensePlateNumber || '', sortable: true },
        { name: 'Kaza Tarihi', selector: row => row.accident?.accidentDate ? new Date(row.accident.accidentDate).toLocaleDateString() : '', sortable: true },
        { name: 'Dosya Türü', selector: row => row.filesToBeWorked?.[0]?.fileType?.title || '', sortable: true },
        { name: 'Azil Durumu', selector: row => row.impeachmentStatus || '', sortable: true },
        { name: 'Çalışılan Tutar', selector: row => row.amountWorked || '', sortable: true },
        { name: "Başvuru Durumu", selector: row => row.applicationStatus || '', sortable: true },
        { name: 'Esas Numarası', selector: row => row.docketNumber || '', sortable: true },
        {
            name: 'Düzenle',
            cell: row => (
                <div className="btn btn-outline-warning d-flex align-items-center justify-content-center" onClick={() => handleCallForm(row)}>
                    <Edit size={18}/>
                </div>
            ),
            ignoreRowClick: true,
            right: true,
            button: true,
        },
    ];

    return (
        <>
            <Breadcrumbs parent='Müşteri Alanları' title='Kaza Dosyaları' />
            <Container fluid={true}>
                <Row>
                    <Col sm='12'>
                        <Card>
                            <CardHeader>
                                <H5>Kaza Dosyaları</H5>
                                <span>Tanımlanmış olan kaza dosyaları aşağıda listelenmektedir.</span>
                            </CardHeader>
                            <CardBody>
                                <div className="d-flex justify-content-end align-items-center w-100 file-content flex-wrap">
                                    <div className='form-inline me-2 mt-3 p-0 custom-responsive-width'>
                                        <div className='mb-0 form-group d-flex align-items-center border rounded px-2' style={{ height: '35px' }}>
                                            <i className='fa fa-search text-muted'></i>
                                            <Input
                                                type="text"
                                                placeholder="Ara.."
                                                value={search}
                                                onChange={(e) => handleSearch(e)}
                                                className="border-0 ms-2 shadow-none"
                                                style={{ height: '33px', flexGrow: 1 }}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div style={{ height: "40px" }}></div>

                                <Fragment>
                                    <DataTable
                                        columns={columns}
                                        data={data}
                                        pagination
                                        paginationServer
                                        selectableRows={false}
                                        paginationTotalRows={totalRows}
                                        onChangePage={page => setPage(page)}
                                        onChangeRowsPerPage={pageSize => setPageSize(pageSize)}
                                    />
                                </Fragment>
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default AccidentFiles;
